import { render, staticRenderFns } from "./listFaq.vue?vue&type=template&id=d976f238&scoped=true&"
import script from "./listFaq.vue?vue&type=script&lang=js&"
export * from "./listFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d976f238",
  null
  
)

export default component.exports